<template>
  <div class="ic-form__r-06">
    <FormWrapper :validator="$v.form">
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-8">
          <p class="mt-3 alert alert-warning" v-html="$t('form_r06_introtext')"></p>
        </div>
      </div>

      <IcFormContactName v-model="form.name" />
      <IcFormContactEmail
        v-model="form.email"
        :withAgreement="true"
        @update:agreement="form.emailAgreement = $event"
        @update:pollAgreement="form.pollAgreement = $event"
      />
      <IcFormContactPhone v-model="form.phone" />
      <IcFormContactAddress v-model="form.address" />

      <h3>Wiadomość</h3>
      <IcFormContactMessage v-model="form.message" />

      <IcFormContactFiles v-model="form.files" />
      <IcFormAgreements v-model="form.agreement" :text="false" :header="false" :modal="true" name="agreement"  :is_visible="false" :value="true"
              :label="$t('label_agreement_checkbox')" content="form_agreement_r06">
      </IcFormAgreements>

      <p>
        Dane osobowe nie będą przekazywane podmiotom trzecim, jednakże zgodnie z obowiązującym prawem Administrator/Współadministrator może przekazywać dane podmiotom przetwarzającym je na zlecenie Administratora/ Współadministratora np. na podstawie umów o powierzenie przetwarzania danych osobowych dostawcom usług IT, audytorom, doradcom, oraz na podstawie obowiązujących przepisów prawa podmiotom uprawnionym do uzyskania danych np. sądom lub organom ścigania – tylko gdy wystąpią z żądaniem uzyskania danych osobowych i wskażą podstawę prawną swego żądania. Dane osobowe mogą być także w razie konieczności udostępnione innym podmiotom jeżeli będzie to niezbędne do rozpatrzenia tego zgłoszenia
      </p>
      <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
    </FormWrapper>
  </div>
</template>

<script>
import IcFormComplaintBase from "./Base/ComplaintBase";
import IcFormContactName from "./Base/Name";
import IcFormContactEmail from "./Base/Email";
import IcFormContactPhone from "./Base/Phone";
import IcFormContactAddress from "./Base/Address";
import IcFormContactMessage from "./Base/Message";
import IcFormContactFiles from "./Base/Files";
import IcFormAgreements from "./Base/Agreements";
import IcFormButtons from "./Base/Buttons";
import validations from "./Validation/r_06.js";
import { Name } from "./Model/Name";
import { Address } from "./Model/Address";
import moment from "moment";

export default {
  name: "IcFormComplaintR06",
  extends: IcFormComplaintBase,
  validations,
  data() {
    return {
      minDate: moment()
        .add(-1, "years")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      form: {
        type: "r06",
        agreement:1,
        name: new Name(),
        emailAgreement: 0,
        phone: "",
        address: new Address(),
        agreement: 1
      }
    };
  },
  components: {
    IcFormContactName,
    IcFormContactPhone,
    IcFormContactEmail,
    IcFormContactAddress,
    IcFormContactMessage,
    IcFormContactFiles,
    IcFormAgreements,
    IcFormButtons
  }
};
</script>

<style>
</style>
